module.exports = __webpack_public_path__ + "img/hypothesis-icon.3adacdd7.png";